import {gql} from 'apollo-boost';
import {ArtworkComplete} from './ArtworkCompleteFragment';

export const LibraryPlaylistComplete = {
  libraryPlaylist: gql`
    fragment LibraryPlaylistComplete on LibraryPlaylist {
      id
      name
      dateAdded
      curatorName
      artwork {
        ...ArtworkComplete
      }
    }
    ${ArtworkComplete.artwork}
  `,
};
